export const biospecimenCategories = [
  {
    title: "Biofluids",
    image: "/images/img_rectangle_27.png",
  },
  {
    title: "Tissue Samples",
    image: "/images/img_rectangle_28.png",
  },
  {
    title: "Cells & Blood Components",
    image: "/images/img_rectangle_29.png",
  },
  {
    title: "Customized Collection",
    image: "/images/img_rectangle_30.png",
  },
];

export const procurementSteps = [
  { title: "Step 01", active: true },
  { title: "Step 02", active: false },
  { title: "Step 03", active: false },
  { title: "Step 04", active: false },
  { title: "Step 05", active: false },
];

export const labServices = [
  {
    title: "RNA/DNA Extraction from diverse biospecimens,",
    description:
      "We offer high-quality RNA/DNA extraction from diverse biospecimens like blood, tissue, and saliva. By combining automated technology with expert protocols, we guarantee pure, intact genetic material ready for PCR, NGS, and Genotyping, ensuring accuracy for both clinical diagnostics and research.",
    image: "/images/img_rectangle_31.png",
    expanded: true,
  },
  {
    title: "Molecular Services: PCR, qPCR, Sequencing,",
    subtitle: "Genomic Analysis & NGS Platforms",
    description:
      "We provide expert molecular solutions featuring high-sensitivity PCR, real-time qPCR, and advanced Sequencing services. Our lab delivers precise genetic insights and data analysis for diverse research and diagnostic needs, ensuring the highest standards of accuracy, speed, and technical excellence.",
    image: "/images/img_rectangle_31.png",
    expanded: true,
  },
  {
    title: "Immunohistochemistry (IHC) & FISH,",
    image: "/images/img_rectangle_31.png",
    description:
      "Our lab offers expert IHC and FISH services to visualize protein expression and genetic markers in tissue samples. Using advanced staining and fluorescence techniques, we deliver precise insights into cellular health and disease, supporting oncology research and clinical pathology with high-fidelity imaging and data.",
    expanded: true,
  },
  {
    title: "Histopathology & Tissue Processing",
    image: "/images/img_rectangle_31.png",
    description:
      "Our lab provides expert Tissue Processing and Histopathology services, ensuring the highest standards of sample preservation and slide preparation. From routine processing to specialized staining, we deliver clear, high-quality tissue sections that are essential for precise microscopic analysis and clinical diagnostics.",
    expanded: true,
  },
];

export const whyChooseAnviya = [
  {
    title: "Ethical Sourcing",
    description:
      "IRB-approved protocols, informed consent, full regulatory compliance for every specimen.",
    gradient: "bg-gradient-to-b from-[#0098b0] to-[#0098b000]",
  },
  {
    title: "Maintained Cold Chain",
    description:
      "Temperature-controlled storage and shipping with continuous monitoring and documentation.",
    gradient: "bg-gradient-to-b from-[#0098b0] to-[#0098b000]",
  },
  {
    title: "SOP-Driven Excellence",
    description:
      "Standardized pre-analytical handling ensures specimen integrity from collection to delivery.",
    gradient: "bg-gradient-to-b from-[#0098b0] to-[#0098b000]",
  },
  {
    title: "Fast Turnaround Time",
    description:
      "Quick diagnostic results and efficient biospecimen procurement to keep your projects on schedule.",
    gradient: "bg-gradient-to-b from-[#0098b0] to-[#0098b000]",
  },
];

export const features = [
  {
    title: "Ethical Sourcing",
    description:
      "IRB-approved protocols, informed consent, full regulatory compliance for every specimen.",
  },
  {
    title: "Maintained Cold Chain",
    description:
      "Temperature-controlled storage and shipping with continuous monitoring and documentation.",
  },
  {
    title: "SOP-Driven Excellence",
    description:
      "Standardized pre-analytical handling ensures specimen integrity from collection to delivery.",
  },
  {
    title: "Fast Turnaround",
    description:
      "Quick diagnostic results and efficient biospecimen logistics to keep your projects moving.",
  },
  {
    title: "SOP-Driven Excellence",
    description:
      "Standardized pre-analytical handling ensures specimen integrity from collection to delivery.",
  },
  {
    title: "Fast Turnaround",
    description:
      "Quick diagnostic results and efficient biospecimen logistics to keep your projects moving.",
  },
];
